var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st0",
    d: "M44,54.3l1.7,1.7l3.6-3.6V62h2.4v-9.7l3.6,3.6l1.7-1.7l-6.5-6.5L44,54.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow_white.d42274c17a0b60439c30fb85c7b3c531.svg";
export { ForwardRef as ReactComponent };